<template>
  <div class="relative">
    <div class="absolute right-4 z-10 bottom-4">
      <Switcher v-model="mapVisible" />
    </div>
    <div class="relative flex flex-col-reverse sm:flex-col" v-if="mapVisible">
      <Selector :map="map" :plots="plots" :disabled="disabled" />
      <div class="sm:absolute bottom-0 mb-8 sm:mb-0 sm:pl-4 w-full">
        <svg
          width="1594"
          height="419"
          viewBox="0 0 1594 419"
          preserveAspectRatio="xMaxYMin meet"
          fill="none"
          style="width: 80%; max-width:1200px"
          class="absolute left-0 -bottom-1 max-w-full h-auto hidden sm:block"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1210.54 271.266C959.888 145.046 859.973 0 64.2606 0H0V418.366H1594C1594 418.366 1467.94 400.899 1210.54 271.266Z"
            fill="white"
          />
        </svg>

        <div class="relative z-10 max-w-sm md:max-w-md xl:max-w-2xl">
          <slot></slot>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="text-center max-w-4xl mx-auto">
        <slot></slot>
      </div>
      <PlotsList :plots="plots" />
    </div>
  </div>
</template>

<script>
import Selector from "./Selector.vue";
import PlotsList from "./PlotsList.vue";
import Switcher from "./Switcher.vue";
export default {
  components: {
    Selector,
    Switcher,
    PlotsList
  },
  props: {
    map: {
      type: String,
      required: true
    },
    showMap: {
      type: Boolean,
      required: true,
      default: false
    },
    plots: {
      type: Array,
      required: true,
      default: []
    }
  },
  data() {
    return {
      mapVisible: this.showMap,
      disabled: this.plots
        .filter(plot => {
          return plot.status != "ledig";
        })
        .map(plot => +plot.post_name.split("-").pop())
    };
  }
};
</script>
